import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Player } from '@lottiefiles/react-lottie-player';
import axios from 'axios';
import API_URL from '../../config';
import { Toast } from 'primereact/toast';
import { useRef } from 'react';
import Swal from 'sweetalert2';
import './StudentLogin.css'; // Custom styling
import './student-animation.json';
import { FiPhone, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { Link } from 'react-router-dom'; // If you're using React Router
import logo from '../../Assets/graduation-cap.jpg';
import studentImage from '../../Assets/student2.png'
import { useNavigate } from 'react-router-dom';
import studentApi from '../Dashboard-Components/StudentApi'

// import graduationCapAnimation from './graduation-cap-icon-animation.json';

const StudentLogin = () => {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [password, setPassword] = React.useState('');
    const [mobile, setMobile] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');


    const handleLogin = async (e) => {
        e.preventDefault();

        if (!mobile.trim() || !password.trim()) {
            return Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Please fill in all fields!',
            });
        }

        try {
            Swal.fire({
                title: 'Logging in...',
                html: 'Please wait while we log you in.',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });

            // ✅ Use studentApi instead of axios
            const response = await studentApi.post('/login', { mobile, password });

            // Save token & user
            localStorage.setItem('student_token', response.data.token);
            localStorage.setItem('studentData', JSON.stringify(response.data.user));

            Swal.close();

            Swal.fire({
                icon: 'success',
                title: 'Login Successful!',
                text: 'Welcome to EduTest 🎉',
                confirmButtonText: 'Go to Get Started Page',
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/get-started');
                }
            });

        } catch (err) {
            Swal.close();
            Swal.fire({
                icon: 'error',
                title: 'Login Failed',
                text: err.response?.data?.message || 'Something went wrong!',
            });
        }
    };


    return (
        <div className="login-container">
            <Toast ref={toast} />
            <motion.div
                className="login-left"
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                style={{ flex: 0.9 }} // smaller width
            >
                <Player
                    autoplay
                    loop
                    src="https://assets2.lottiefiles.com/packages/lf20_touohxv0.json" // student studying animation
                    style={{ height: '100%', width: '100%', maxWidth: '400px' }}
                />
            </motion.div>
            <motion.div
                className="login-right"
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 1 }}
                style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <div className="login-box">
                    {/* <img src={logo} alt="logo" className="login-image" /> */}
                    {/* <Player
                        autoplay
                        loop
                        src={graduationCapAnimation}
                        style={{ height: '120px', width: '120px', marginBottom: '1rem' }}
                    /> */}
                    {/* <h1 className="hello-text">Hello!</h1>
                    <h2 className="welcome-heading">
                        <span className="wave-emoji">👋</span> Welcome Students
                    </h2> */}

                    <div className="login-header">
                        <img
                            src={studentImage}
                            alt="Student Illustration"
                            className="student-image avatar-floating"
                        />
                        <h1 className="hello-text">Hello!</h1>
                        <h2 className="welcome-heading">
                            <span className="wave-emoji">👋</span> Welcome Students
                        </h2>
                    </div>


                    <form onSubmit={handleLogin}>
                        <motion.div className="input-group">
                            <FiPhone className="icon" />
                            <input
                                type="text"
                                name="username"              //standard name
                                placeholder="Mobile Number"
                                autoComplete="username"      //tells browser this is login username
                                required
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                            />
                        </motion.div>

                        <motion.div className="input-group">
                            <FiLock className="icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"              //standard name
                                placeholder="Password"
                                autoComplete="current-password" //tells browser this is login password
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div
                                className="toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </div>
                        </motion.div>


                        {error && <p className="error-text">{error}</p>}
                        <a href="#" className="forget-password">Forgot password?</a>


                        {/* ✅ Lottie Loading Animation */}
                        {loading && (
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                <Player
                                    autoplay
                                    loop
                                    src="https://assets9.lottiefiles.com/packages/lf20_usmfx6bp.json"
                                    style={{ height: '60px', width: '60px' }}
                                />
                            </div>
                        )}

                        <button type="submit" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                        {/* <button type="submit">Login</button> */}

                        <div className="signup-link">
                            <p>
                                Don't have an account? <Link to="/signup">Sign up</Link>
                            </p>
                        </div>

                        <div className="admin-login-link">
                            <p>
                                <Link to="/admin-login">Login as Administrator</Link>
                            </p>
                        </div>
                    </form>
                </div>
            </motion.div>
        </div>
    );
};

export default StudentLogin;
